// tslint:disable:max-line-length
import * as React from 'react';

export enum COUNTRY_INITIALS {
    MEXICO = 'MX'
}

export enum COUNTRY_NAME {
    MEXICO = 'México'
}

export const AUTHORIZATION_SERVERLESS = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoibGF0YW1hdXRvcyIsImlhdCI6MTU0ODcwMzEwM30.Y7SOEusL36GAXH4KmrsZ407jwo_P2u-Aqqomp6G9ctY';

export const LEGAL_CONTENT = <React.Fragment>
    <div className="text-muted text-justify">
        <p>
            Latamautos México, S. de R.L. de C.V., de conformidad con lo dispuesto por la Ley Federal de Protección
            de Datos Personales en Posesión de los Particulares, su Reglamento y diversa normativa vigente y
            relacionada, trataremos sus datos única y exclusivamente para los fines descritos en el
            Aviso de Privacidad Integral.  Asimismo, usted dispone de los derechos de acceso, rectificación,
            cancelación y oposición de sus datos personales, para ejercer los mismos, favor de contactarnos a <a href="mailto:ayuda@motorfy.com"><span className="font-weight-bold">ayuda@motorfy.com</span></a>,
            para conocer nuestro Aviso de Privacidad Integral, puede acceder a la siguiente liga: <a href="https://mx.motorfy.com/legal" target="_blank"><span className="font-weight-bold">https://mx.motorfy.com/legal</span></a>
        </p>
        <p>
            Por medio de la presente, autorizo expresamente a la Sociedad denominada Latamautos México,
            S. de R.L. de C.V. para que lleve a cabo investigaciones sobre mi comportamiento crediticio en
            relación jurídica y la transferencia de mi información a las Entidades Financieras con las que
            mantiene alianzas, a fin de que lleve a cabo la consulta de mis antecedentes crediticios;
            cumplimiento de mis obligaciones derivadas de cualquier relación jurídica con Entidades Financieras;
            calificaciones de crédito o riesgos; y, el comportamiento de mi historial crediticio, a través de
            Sociedades de Información Crediticia, por lo que, asimismo, autorizo la transferencia de mi información
            a estas últimas.
        </p>
        <p>
            Acepto que este documento quede bajo propiedad de Latamautos México, S. de R.L. de C.V. para efectos
            de control y cumplimiento del artículo 28 de la Ley para Regular las Sociedades de Información
            Crediticia “LRSIC”, consintiendo que esta autorización se encontrará vigente por un periodo de 3 (tres)
            años contados a partir de su expedición y en todo caso durante el tiempo que se mantenga la
            relación jurídica.
        </p>
    </div>
</React.Fragment>;

export const BUREAU_AUTHORIZATION_REQUEST = <React.Fragment>
    <div className="text-muted text-justify">
        <p> Autorizo expresamente a Latamautos México, S. de R.L de C.V., para que lleve a cabo investigaciones sobre mi
            comportamiento crediticio en las Sociedades de Información Crediticia (SIC) que estime conveniente. Conozco
            la naturaleza y alcance de la información que se solicitará, del uso que se le dará y que se podrán realizar
            consultas periódicas de mi historial crediticio. </p>
        <p> Consiento que esta autorización tenga una vigencia de 3 años contados a partir de hoy, y en su caso mientras
            mantengamos relación jurídica. </p>
        <p> Acepto que este documento quede bajo propiedad de Latamautos México, S. de R.L de C.V. y/o SIC Consultada
            para efectos de control y cumplimiento del artículo 28 de la LRSIC. </p>
    </div>
</React.Fragment>;

export const ELECTRONIC_MEDIA_LEGAL_CONTENT = <React.Fragment>
    <div className="text-muted text-justify">
        <p>Cláusula para utilizar medios electrónios de autentificación.</p>
        <p>
            Las partes acuerdan que el CLIENTE podrá expresar su consentimiento respecto a la presente cláusula, así como
            tener acceso a los servicios ofrecidos por Latamautos México, S. de R. L. de C.V.  mediante medios electrónicos tales como NIP.
        </p>
        <p>
            Asimismo, usted dispone de los derechos de acceso, rectificación, cancelación y oposición de sus datos personales,
            para ejercer los mismos, favor de contactarnos a <a href="mailto:ayuda@motorfy.com"><span
            className="font-weight-bold">ayuda@motorfy.com</span></a>, para conocer nuestro Aviso de Privacidad Integral,
            puede acceder a la siguiente liga: <a href="https://mx.motorfy.com/legal"
            target="_blank"><span className="font-weight-bold">https://mx.motorfy.com/legal</span></a>
        </p>
    </div>
</React.Fragment>;

export const GOOGLE_MAP_API_KEY = 'AIzaSyDLurWahBAbX--qjX8WP0-iKM1aXbnHN2Y';
